const statePostcodeRanges = {
    NSW: [
        { min: 1000, max: 1999 }, // po boxes
        { min: 2000, max: 2599 },
        { min: 2619, max: 2899 },
        { min: 2921, max: 2999 },
        { min: 3644, max: 3644 },
        { min: 3691, max: 3691 },
        { min: 3707, max: 3707 },
        { min: 4375, max: 4375 },
        { min: 4377, max: 4377 },
        { min: 4380, max: 4380 },
        { min: 4383, max: 4383 },
        { min: 4385, max: 4385 },
    ],
    ACT: [
        { min: 200, max: 299 }, // po boxes
        { min: 2600, max: 2618 },
        { min: 2900, max: 2920 },
    ],
    VIC: [
        { min: 3000, max: 3996 },
        { min: 8000, max: 8999 }, // po boxes
    ],
    QLD: [
        { min: 4000, max: 4999 },
        { min: 9000, max: 9999 }, // po boxes
    ],
    SA: [
        { min: 5000, max: 5799 },
        { min: 5800, max: 5999 }, // po boxes
    ],
    WA: [
        { min: 6000, max: 6797 },
        { min: 6800, max: 6999 }, // po boxes
    ],
    TAS: [
        { min: 7000, max: 7799 },
        { min: 7800, max: 7999 }, // po boxes
    ],
    NT: [
        { min: 800, max: 899 },
        { min: 900, max: 999 }, // po boxes
    ],
};
const externalTerritories = [2899, 6798, 6799, 7151];
export const blockedPostcodes = [...externalTerritories];
/**
 * Custom hook providing address validation utilities.
 */
export function useAddressValidation() {
    const validatePostcode = (postcode) => {
        const postcodePattern = /^\d{4}$/;
        if (!postcodePattern.test(postcode)) {
            return {
                isValid: false,
                errorMessage: 'Please enter a valid 4-digit postcode.',
            };
        }
        return { isValid: true };
    };
    const validateParcelLocker = (value) => {
        const parcelLockerPattern = /(\d{5}\s?\d{5})?\s?(parcel\s*?locker)\s?(\d{5}\s?\d{5})?/i;
        if (parcelLockerPattern.test(value)) {
            return {
                isValid: false,
                errorMessageTitle: 'Parcel Lockers are not allowed.',
                errorMessage: 'Please use a residential, business, or PO Box address.',
            };
        }
        return { isValid: true };
    };
    const validateStreetNumber = (value) => {
        const hasStreetNumber = value.address_components.some((component) => component.types.includes('street_number') && component.long_name);
        if (!hasStreetNumber) {
            return {
                isValid: false,
                errorMessageTitle: 'Invalid address.',
                errorMessage: 'Please type street number.',
            };
        }
        return { isValid: true };
    };
    // ensures a given postcode matches the selected state, and vice versa
    const validateStateBelongsToPostcode = (postcode, state) => {
        if (!state || !postcode) {
            return { isValid: true };
        }
        const postcodeNum = parseInt(postcode, 10);
        if (isNaN(postcodeNum)) {
            return { isValid: true };
        }
        const ranges = statePostcodeRanges[state];
        if (!ranges) {
            return { isValid: true };
        }
        const isValid = ranges.some((range) => postcodeNum >= range.min && postcodeNum <= range.max);
        return {
            isValid,
            errorMessage: isValid ? undefined : 'Postcode does not match the selected state.',
        };
    };
    const validatePostcodeNotBlockedFromDelivery = (postcode) => {
        const postcodeNum = parseInt(postcode, 10);
        if (isNaN(postcodeNum)) {
            return { isValid: true };
        }
        const isValid = !blockedPostcodes.includes(postcodeNum);
        return {
            isValid,
            errorMessage: isValid
                ? undefined
                : 'Delivery and Click & Collect are not available to this location. Please contact support.',
        };
    };
    return {
        validatePostcode,
        validateParcelLocker,
        validateStreetNumber,
        validateStateBelongsToPostcode,
        validatePostcodeNotBlockedFromDelivery,
    };
}
//# sourceMappingURL=data:application/json;base64,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